import { ReactElement } from 'react';
import { Controller } from 'react-hook-form';

import { ErrorOutlineOutlined as ErrorOutlineOutlinedIcon } from '@mui/icons-material';
import { Alert, AlertTitle, Grow } from '@mui/material';

import { Event, FormProps } from './types';

import VStack from '../../../Stacks/VStack';
import TextField from '../../../TextField';

export default function Form({ form, isError = false, onKeypress }: FormProps): ReactElement {
  return (
    <VStack spacing={2}>
      <Grow in={isError} unmountOnExit style={{ width: '100%' }}>
        <Alert
          iconMapping={{
            error: <ErrorOutlineOutlinedIcon sx={{ color: 'error.main' }} />
          }}
          severity='error'>
          <AlertTitle>Oh no! 😢</AlertTitle>
          Something went wrong. Please try again later!
        </Alert>
      </Grow>

      {/* Full Name */}
      <Controller
        control={form.control}
        name='fullname'
        render={({ field: { onChange, onBlur, value, name }, fieldState: { error } }) => (
          <TextField
            id={name}
            name={name}
            label='Full name'
            errorMessage={error?.message}
            fullWidth
            type='text'
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={(event: Event) => onKeypress(event)}
            value={value}
          />
        )}
      />

      {/* Email */}
      <Controller
        control={form.control}
        name='email'
        render={({ field: { onChange, onBlur, value, name }, fieldState: { error } }) => (
          <TextField
            id={name}
            name={name}
            label='Email'
            errorMessage={error?.message}
            fullWidth
            type='email'
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={(event: Event) => onKeypress(event)}
            value={value}
          />
        )}
      />
    </VStack>
  );
}
